// DEPENDENCIES
import React from 'react';
import { render } from 'react-dom';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import 'url-search-params-polyfill';
import 'babel-polyfill';
import smoothScroll from 'smoothscroll-polyfill';


import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { browserHistory } from 'react-router';

import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';

// MIDDELWARES
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

// INNER IMPORTS
import Routes from './routes';
import reducer from './Reducers/index';
import './defaults.css';
import './index.css';
import './media.css';
import { LocalStorageService } from "./Services";

// kick off the polyfill!
smoothScroll.polyfill();

const middlewares = [thunk];

middlewares.push(routerMiddleware(browserHistory));

if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'staging') {
    const logger = createLogger({
        collapsed: true,
    });

    middlewares.push(logger);
}

// middleware that includes thunk - which should enable dispatch more than one action in order
const middleware = applyMiddleware(...middlewares);
// declaring the store that wraps the whole application
const store = createStore(reducer, middleware);

const history = syncHistoryWithStore(browserHistory, store);

store.subscribe(() => {
    if (typeof localStorage === 'undefined') return;

    LocalStorageService.setInitialState(store.getState());
});

render(
    <Provider store={store}>
        <Routes history={history} />
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js